<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-building"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>SAML sign in</h2>
                <p>Select your organisation's domain to continue with SAML single sign-on.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-building"></i><span>Enterprise SSO</span></li>
                    <li><i class="fa fa-shield"></i><span>Organisation-verified access</span></li>
                    <li><i class="fa fa-bolt"></i><span>Fast, seamless sign-on</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="domainForm" class="login-form" autocomplete="off" (ngSubmit)="signInSAML()">
                <h1 class="login-title">Sign in to SAML</h1>
                <p class="login-subtitle">Choose your organisation domain to continue.</p>

                <div class="login-field">
                    <label for="domainSelect">Select domain</label>
                    <div class="domain-select-wrap">
                        <i class="fa fa-globe domain-select-icon" aria-hidden="true"></i>
                        <select class="domain-select" id="domainSelect" (change)="changeDomain($event)"
                            formControlName="domainName">
                            <option value="" disabled selected hidden>Select domain</option>
                            <ng-container *ngFor="let obj of domainList">
                                <option [value]="obj.key">{{ obj.value }}</option>
                            </ng-container>
                        </select>
                        <i class="fa fa-chevron-down domain-select-chevron" aria-hidden="true"></i>
                    </div>
                    <div *ngIf="domainName?.invalid && domainForm.get('domainName').touched">
                        <span class="login-error"
                            *ngIf="domainForm.get('domainName').touched && domainForm.get('domainName').errors?.required">Please Select Domain</span>
                    </div>
                </div>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit"
                    [disabled]="!domainForm.valid">NEXT</button>

                <div class="login-links">
                    <a [routerLink]="'/login'">Sign in using credentials</a>
                </div>
            </form>
        </section>
    </div>
</div>
